<div class="quickbet-content qb-partial-overlay srm-selection" data-crlat="quickbet.content">
    <div class="quickbet-sectionwrap">
        <section class="qb-po-selection-close-btn" [style.visibility]="selection.disabled ? 'hidden' : 'visible'">
            <div class="qb-po-sln-close-btn" data-crlat="selectionCloseButton" (click)="removeSelection()">
                <svg>
                    <use xlink:href="#close-icon"></use>
                </svg>
            </div>
        </section>

        <section class="qb-content-info srm-content-info">
            <div class="selection-outcome-info">
                <p class="outcome-name" [i18n]="'quickbet.sameRaceMulti'" data-crlat="selectionName"></p>
            </div>
            @for (qa of selectedQuestionAndAnswers; track qa.question) {
                <p class="market-name" [textContent]="qa.question" data-uat="marketName" data-crlat="marketName"></p>
                <p class="event-name" [textContent]="qa.answer" data-uat="eventName" data-crlat="eventName"></p>
            }
        </section>

        <section id="quickBetEW" class="qb-stake-section" data-crlat="section.stake">
            <div class="qb-odds-stake-wrapper">
                <div class="odds" [style.visibility]="selection.disabled ? 'hidden' : 'visible'">
                    <span class="odds-value" [textContent]="srmOdds" data-crlat="odds"></span>
                </div>
                <div class="stake" data-crlat="stake.amountInputForm" [ngClass]="{ suspended: selection.disabled }">
                    <label
                        [ngClass]="selectionAmountClasses"
                        class="input-stake-label"
                        [attr.data-currency]="selection.currency"
                        [textContent]="selection.stake ? selection.currency : ''">
                    </label>
                    <input
                        id="stake-input"
                        class="stake-input"
                        placeholder="Stake"
                        (click)="openFullOverlay($event)"
                        [disabled]="selection.disabled || serviceClosureService.userServiceClosureOrPlayBreak"
                        [(ngModel)]="selection.stake"
                        data-crlat="value" />
                </div>
            </div>
        </section>
    </div>
</div>
